// (function () {
//   if (window.__redoSkipShopPayBound) return;
//   window.__redoSkipShopPayBound = true;

//   function handler(e) {
//     var redoEl = document.querySelector('redo-shopify-toggle');
//     if (!redoEl) return;
//     var path = e.composedPath();
//     if (!path.includes(redoEl)) return;

//     e.preventDefault();
//     e.stopImmediatePropagation();
//     if (e.type === 'click' || e.type === 'pointerup' || e.type === 'mouseup') {
//       window.location.href = '/checkout?skip_shop_pay=true';
//     }
//   }

//   ['pointerdown', 'mousedown', 'pointerup', 'mouseup', 'click', 'touchstart', 'touchend'].forEach(function (t) {
//     window.addEventListener(t, handler, true);
//     document.addEventListener(t, handler, true);
//   });
// })();
// bindRedoCheckout(); // file load pe ek baar

// function replaceRebuyCheckoutButton() {
//   document.querySelectorAll('.rebuy-cart__checkout-button').forEach((button) => {
//     if (
//       button.tagName === 'A' &&
//       button.getAttribute('href') === '/checkout?skip_shop_pay=true'
//     ) {
//       return;
//     }

//     const checkoutLink = document.createElement('a');
//     checkoutLink.href = '/checkout?skip_shop_pay=true';
//     checkoutLink.className = button.className;
//     checkoutLink.innerHTML = '<span>Checkout</span>';

//     button.replaceWith(checkoutLink);
//   });

  
// const redoEl = document.querySelector('redo-shopify-toggle');

// if (redoEl && redoEl.root) {
//   const root = redoEl.root;

//   console.log('Root type:', root.constructor.name);
//   console.log('Root mode:', root.mode);

//   const style = document.createElement('style');

//   style.textContent = `
//    div[data-target="checkout-buttons-container"] button.w-full {
//     position: relative;
//     display: inline-block;
//     width: 100%;
//     height: 60px;
//     background-color: transparent !important;
//     border: none !important;  
//     cursor: pointer;
//     padding: 0 !important;
//     border-radius: 6px !important;
// }
// div[data-target="checkout-buttons-container"] button.w-full>div {         
//     position: relative !important;
//     display: inline-block !important;
//     font-size: 15px !important;
//     text-transform: uppercase !important;
//     top: 0; left: 0 !important;
//     width: 100% !important;
//     padding: 16px 20px !important;
//     transition: 0.3s !important;
//   }
// div[data-target="checkout-buttons-container"] button.w-full::before,
// div[data-target="checkout-buttons-container"] button.w-full::after {
//   position: absolute !important;
//   content: "" !important;
//     border-radius: 6px;
// }

// div[data-target="checkout-buttons-container"] button.w-full::before {
//   background-color: #171717 !important;
//   transition: 0.3s ease-out !important;
// }
// div[data-target="checkout-buttons-container"] button.w-full>div {
//     color: rgb(255, 255, 255) !important;
//     border: 2px solid #171717 !important;
//     transition: 0.2s 0.1s !important;
//     border-radius: 6px;
// }
// div[data-target="checkout-buttons-container"] button.w-full>div:hover {
//   color: #171717 !important;
//   transition: 0.2s 0.1s !important;
// }
// div[data-target="checkout-buttons-container"] button.w-full::before {
//   top: 0; left: 0; right: 0 !important;
//   height: 100%; width: 100% !important;
// }
// div[data-target="checkout-buttons-container"] button.w-full:hover::before {
//   height: 0% !important;
// }
// div[data-target="checkout-buttons-container"] button.w-full>div p {
//     color: #FFF !important;
// }
// div[data-target="checkout-buttons-container"] button.w-full:hover>div p {
//     color: #171717 !important;
// }
//   `;

//   root.appendChild(style);
//   console.log('Style element added.');
// }
// //  bindRedoCheckout(); 

// }

// document.addEventListener('rebuy:smartcart.ready', replaceRebuyCheckoutButton);
// document.addEventListener('rebuy:smartcart.show', replaceRebuyCheckoutButton);
// document.addEventListener('rebuy:cart.change', replaceRebuyCheckoutButton);

// const interval = setInterval(() => {
//     const redoEl = document.querySelector('redo-shopify-checkbox');
 
//     if (redoEl && redoEl.shadowRoot) {
//       const style = document.createElement('style');
//       style.textContent = `
//         ._5-4 {
//           max-width: calc(100% - 100px);
//         }
//         div[data-target="checkbox-root"] {
//           align-items: flex-start;
//         }
//         span[data-target="checkbox-label"] {
//           flex: 0 0 auto !important;
//           padding: 0 5px 0 0 !important;
//         }
//         span[data-target="checkbox-info"] {
//           width: 16px;
//           height: 16px;
//         }
//       `;
//       redoEl.shadowRoot.appendChild(style);
//       if(redoEl.shadowRoot.querySelector('[data-target="checkbox-label"]')){
//         redoEl.shadowRoot.querySelector('[data-target="checkbox-label"]').innerHTML ="<strong> Add $5.98 Return Protection for Free 30-Day Return Shipping </strong>";
//       clearInterval(interval);
//       }
//     }
// }, 300);


// // Select the elements
// const interval_wrap = setInterval(() => {
//   const redoCheckbox = document.querySelector("#redo-checkbox");
//   const questionWrapper = document.querySelector(".question-wrapper");
//   if (questionWrapper && document.querySelector("#redo-checkbox")) {
//     clearInterval(interval_wrap)
//   }
  
  
//   const wrapper = document.createElement("div");
//   wrapper.className = "redo-question-wrapper"; // optional class
//   if(document.querySelector("#redo-checkbox")){
//       document.querySelector("#redo-checkbox").classList.add("redo-question-wrapper")
//       document.querySelector("#redo-checkbox").appendChild(questionWrapper);
//    }
// },200)
// ---------------------------------------------------------------
// Redo ka click rokne ki jagah, uska final redirect pakad ke
// normal checkout (skip_shop_pay=true) pe bhejte hain.
// Isse Redo apna "Return Protection item add" step normal tarah karta hai.
// ---------------------------------------------------------------
(function () {
  if (window.__redoNavFix) return;
  window.__redoNavFix = true;

  if (!window.navigation) {
    console.warn('Navigation API not supported in this browser');
    return;
  }

  const TARGET = '/checkout?skip_shop_pay=true';

  navigation.addEventListener('navigate', function (e) {
    if (!e.cancelable) return;

    let url;
    try {
      url = new URL(e.destination.url);
    } catch (err) {
      return;
    }

    const sameHost = url.hostname === location.hostname;
    const isStoreCheckout =
      sameHost &&
      url.pathname === '/checkout' &&
      !url.searchParams.has('skip_shop_pay');
    const isShopPay = url.hostname === 'shop.app';

    if (isStoreCheckout || isShopPay) {
      console.log('Redirect intercepted:', url.href);
      e.preventDefault();
      setTimeout(function () {
        window.location.href = TARGET;
      }, 0);
    }
  });
})();

function replaceRebuyCheckoutButton() {
  document.querySelectorAll('.rebuy-cart__checkout-button').forEach((button) => {
    if (
      button.tagName === 'A' &&
      button.getAttribute('href') === '/checkout?skip_shop_pay=true'
    ) {
      return;
    }

    const checkoutLink = document.createElement('a');
    checkoutLink.href = '/checkout?skip_shop_pay=true';
    checkoutLink.className = button.className;
    checkoutLink.innerHTML = '<span>Checkout</span>';

    button.replaceWith(checkoutLink);
  });

  const redoEl = document.querySelector('redo-shopify-toggle');

  if (redoEl && redoEl.root) {
    const root = redoEl.root;

    // duplicate style rokne ke liye guard
    if (root.querySelector('#custom-redo-style')) return;

    const style = document.createElement('style');
    style.id = 'custom-redo-style';

    style.textContent = `
   div[data-target="checkout-buttons-container"] button.w-full {
    position: relative;
    display: inline-block;
    width: 100%;
    height: 60px;
    background-color: transparent !important;
    border: none !important;  
    cursor: pointer;
    padding: 0 !important;
    border-radius: 6px !important;
}
div[data-target="checkout-buttons-container"] button.w-full>div {         
    position: relative !important;
    display: inline-block !important;
    font-size: 15px !important;
    text-transform: uppercase !important;
    top: 0; left: 0 !important;
    width: 100% !important;
    padding: 16px 20px !important;
    transition: 0.3s !important;
  }
div[data-target="checkout-buttons-container"] button.w-full::before,
div[data-target="checkout-buttons-container"] button.w-full::after {
  position: absolute !important;
  content: "" !important;
    border-radius: 6px;
}

div[data-target="checkout-buttons-container"] button.w-full::before {
  background-color: #171717 !important;
  transition: 0.3s ease-out !important;
}
div[data-target="checkout-buttons-container"] button.w-full>div {
    color: rgb(255, 255, 255) !important;
    border: 2px solid #171717 !important;
    transition: 0.2s 0.1s !important;
    border-radius: 6px;
}
div[data-target="checkout-buttons-container"] button.w-full>div:hover {
  color: #171717 !important;
  transition: 0.2s 0.1s !important;
}
div[data-target="checkout-buttons-container"] button.w-full::before {
  top: 0; left: 0; right: 0 !important;
  height: 100%; width: 100% !important;
}
div[data-target="checkout-buttons-container"] button.w-full:hover::before {
  height: 0% !important;
}
div[data-target="checkout-buttons-container"] button.w-full>div p {
    color: #FFF !important;
}
div[data-target="checkout-buttons-container"] button.w-full:hover>div p {
    color: #171717 !important;
}
  `;

    root.appendChild(style);
    console.log('Style element added.');
  }
}

document.addEventListener('rebuy:smartcart.ready', replaceRebuyCheckoutButton);
document.addEventListener('rebuy:smartcart.show', replaceRebuyCheckoutButton);
document.addEventListener('rebuy:cart.change', replaceRebuyCheckoutButton);

const interval = setInterval(() => {
  const redoEl = document.querySelector('redo-shopify-checkbox');

  if (redoEl && redoEl.shadowRoot) {
    const style = document.createElement('style');
    style.textContent = `
        ._5-4 {
          max-width: calc(100% - 100px);
        }
        div[data-target="checkbox-root"] {
          align-items: flex-start;
        }
        span[data-target="checkbox-label"] {
          flex: 0 0 auto !important;
          padding: 0 5px 0 0 !important;
        }
        span[data-target="checkbox-info"] {
          width: 16px;
          height: 16px;
        }
      `;
    redoEl.shadowRoot.appendChild(style);
    if (redoEl.shadowRoot.querySelector('[data-target="checkbox-label"]')) {
      redoEl.shadowRoot.querySelector('[data-target="checkbox-label"]').innerHTML =
        '<strong> Add $5.98 Return Protection for Free 30-Day Return Shipping </strong>';
      clearInterval(interval);
    }
  }
}, 300);

// Select the elements
const interval_wrap = setInterval(() => {
  const redoCheckbox = document.querySelector('#redo-checkbox');
  const questionWrapper = document.querySelector('.question-wrapper');
  if (questionWrapper && document.querySelector('#redo-checkbox')) {
    clearInterval(interval_wrap);
  }

  const wrapper = document.createElement('div');
  wrapper.className = 'redo-question-wrapper'; // optional class
  if (document.querySelector('#redo-checkbox')) {
    document.querySelector('#redo-checkbox').classList.add('redo-question-wrapper');
    document.querySelector('#redo-checkbox').appendChild(questionWrapper);
  }
}, 200);